<template>
<div>
      <v-row class="flex-wrap justify-center">
        <v-col v-for="(project, i) in projects"
               :key="i"
               cols="12"
               class="service-col">
          <v-card v-ripple="project.href ? {class: 'soft-ripple'} : false"
                  data-aos="fade-up"
                  :data-aos-duration="800"
                  :data-aos-delay="400*i"
                  class="card-shadow fill-height"
                  :href="project.href ? project.href : ''"
                  :target="project.href ? '_blank' : ''">
            <div class="service-icon-tile dark-gradient d-flex align-center justify-center" style="height: 250px;">
              <v-icon size="88" color="white">{{ project.icon }}</v-icon>
            </div>
            <div class="py-1 px-3">
              <v-card-title class="primary--text mb-1">{{project.title}}</v-card-title>
              <v-card-subtitle>{{project.subtitle}}</v-card-subtitle>
            </div>
          </v-card>
        </v-col>
      </v-row>
</div>

</template>

<script>

import GlobalComputed from '@/helpers/global-computed'
import servicesEn from '@/assets/generated/services.en.json'
import servicesDe from '@/assets/generated/services.de.json'
//import MySection from '@/components/MySection'

const icons = [
  'mdi-code-braces',
  'mdi-server-security',
  'mdi-cloud-upload-outline',
  'mdi-robot-outline',
];

export default {
name: 'Services',
  components: {
    //MySection,
  },

  computed: {
    ...GlobalComputed,
      bgImage() {
                return this.isLandscape ? this.bgImageMobile : this.bgImageDesktop;
            },
      projects(){
        const services = this.$i18n.locale === 'de' ? servicesDe : servicesEn;
        return services.map((service, i) => ({ ...service, icon: icons[i] }));
      },
        },
}

</script>

/*
view-source:http://michalsnik.github.io/aos/
view-source:http://michalsnik.github.io/aos/dist/css/styles.css
*/

<style lang="scss" scoped>

.karte {
  width: 40%;
  clear: both;
  background: #FFF;
  padding: 2vh;
}

/* must be 'hidden' here.
   Otherwise, layout doesn't work on android
*/
.karte--right {
  margin: 0vh 5vh 0vh 0vh;
  float: right;
  overflow: hidden;
}
.karte--left {
  margin: 0vh 0vh 0vh 5vh;
  float: left;
}
section{



} /* section */

.fade-out-enter, .fade-out-leave{
  opacity: 1;
}
.fade-out-leave-to{
  opacity: 0;
}
.fade-out-enter-active, .fade-out-leave-active{
  transition: opacity 0.4s ease-in-out;
}

.dark-gradient{
  background-color: #050a19!important;
  background: linear-gradient(125deg, rgba(5,10,25,1) 45%, rgb(3, 16, 53) 100%)!important;
}

.service-icon-tile {
  border-radius: 4px 4px 0 0;
}

/* Vuetify's 12-column grid has no "one fifth", so the five service cards are
   sized by flex-basis instead of a col-* class from md up. */
@media (min-width: 960px) {
  .service-col {
    flex: 0 0 20%;
    max-width: 20%;
  }
}

/* Vuetify defaults .v-card__title to word-break: break-all, which splits
   words mid-character (e.g. "Souverän|e Infrastruktur"). */
::v-deep .v-card__title {
  word-break: normal;
  overflow-wrap: anywhere;
}


.fullpage-section{
  height: 100vh;
  position: relative;
}

.soft-ripple{
  color: rgba(0,0,0, .2)!important;
}

.v-card{
  &.card-shadow{
            box-shadow: 0 1px 4px 0 rgba(0,0,0, .1)!important;
            transition: 0.15s ease-in-out all;
            
            @media(min-width: 960px){
                &:hover{
                    box-shadow: 0 3px 15px 0 rgba(0,0,0, .08)!important;
                    transform: translateY(-6px);
                }
  }
  &.v-card--link{
                &:before{
                    opacity: 0!important;
                }
                &:active{
                    transform: translateY(1px);
                    box-shadow: 0 1px 3px 0 rgba(0,0,0, .1)!important;
                }
            }
  }
}

    
  /* transitions */
  .delay-500ms {
        transition-delay: 0.5s!important;
  }

  .delay-1s{
        transition-delay: 1s!important;
  }

  .delay-2s{
        transition-delay: 2s!important;
  }

  .delay-3s{
        transition-delay: 3s!important;
  }

  .delay-4s{
        transition-delay: 4s!important;
  }

  .fade-up-off{
        opacity: 0;
        transform: translateY(200px);
  }

  .fade-up-on{
        opacity: 1;
        transform: none;
        transition: opacity 1s ease-in, transform 0.5s ease-out;
  }


</style>
